import { Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

let setGlobalError: ((error: Error) => void) | null = null;

export const initializeErrorHandler = (errorSetter: (error: Error) => void) => {
  setGlobalError = errorSetter;
};

interface ConnectionError extends Error {
  isConnectionError?: boolean;
}

export const errorMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = action.payload as ConnectionError;
    
    if (error?.isConnectionError && setGlobalError) {
      setGlobalError(error);
    }
  }

  return next(action);
}; 